import {
  Badge,
  Col,
  Dropdown,
  Input,
  notification,
  Tooltip,
  Pagination,
  Popconfirm,
  Row,
  Spin,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import {
  DeleteGeoTagEmployeeApi,
  GetGeoTagEmployeesApi,
} from "../../../../Services/GeoTag";
import "./Employee.css";
import { MdPersonAdd, MdDelete, MdEdit, MdAdd } from "react-icons/md";
import AddEmployee from "./AddEmployee";
import { BiChevronDown, BiFilterAlt } from "react-icons/bi";
import UpdateEmployee from "./UpdateEmployee";
import { LoadingOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { checkPleaseLogin } from "../../../../Services/GeneralFunctions";
import AssetReq from "./AssetReq";

const { Search } = Input;

export default function Employee() {
  const [api, contextHolder] = notification.useNotification();

  const initialRender = useRef(true);

  const navigate = useNavigate();
  const [idAsset, setIdAsset] = useState(null);

  const [employeesData, setEmployeesData] = useState(null);
  const [addEmployeeToggle, setAddEmployeeToggle] = useState(false);
  const [updateEmployeeToggle, setUpdateEmployeeToggle] = useState(false);
  const [assetReqToggle, setAssetReqToggle] = useState(false);

  const [defaultValues, setDefaultValues] = useState(null);

  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(10);

  const [isActiveFilter, setIsActiveFilter] = useState(null);

  const [isGeotagFilter, setIsGeotagFilter] = useState(null);

  const [employeeIdFilter, setEmployeeIdFilter] = useState("");
  const [employeeNameFilter, setEmployeeNameFilter] = useState("");

  const [tableLoader, setTableLoader] = useState(false);

  const nofilterData = async () => {
    const res = await checkPleaseLogin(navigate);
    if (res) {
      return;
    }

    setEmployeesData(null);
    try {
      setTableLoader(true);
      const data = await GetGeoTagEmployeesApi(page, "", "", "", "");
      setTableLoader(false);

      if (
        data.data.message === "Please Login." ||
        data.data.message === "Invalid Access Token"
      ) {
        navigate("/auth");
      }

      if (data.data.success) {
        setEmployeesData(data.data.data.data);
        setTotal(data.data.data.page_count * 10);
        console.log(data.data.data.data);
      } else {
        api.error({
          message: "Error while fetching Employees List",
          description: data.data.message,
          placement: "top",
        });
      }
    } catch (err) {
      setTableLoader(false);
      api.error({
        message: err.message,
        description: "Try to check your Internet Connection.",
        placement: "top",
      });
    }
  };

  const idNameFilteredData = async () => {
    const res = await checkPleaseLogin(navigate);
    if (res) {
      return;
    }

    setEmployeesData(null);
    try {
      setTableLoader(true);
      const data = await GetGeoTagEmployeesApi(
        page,
        "",
        employeeIdFilter,
        employeeNameFilter,
        ""
      );
      setTableLoader(false);

      if (
        data.data.message === "Please Login." ||
        data.data.message === "Invalid Access Token"
      ) {
        navigate("/auth");
      }

      if (data.data.success) {
        setEmployeesData(data.data.data.data);
        setTotal(data.data.data.page_count * 10);
        console.log(data.data.data.data);
      } else {
        api.error({
          message: "Error while fetching Employees List",
          description: data.data.message,
          placement: "top",
        });
      }
    } catch (err) {
      setTableLoader(false);
      api.error({
        message: err.message,
        description: "Try to check your Internet Connection.",
        placement: "top",
      });
    }
  };

  const isActiveFilteredData = async () => {
    const res = await checkPleaseLogin(navigate);
    if (res) {
      return;
    }

    setEmployeesData(null);
    try {
      setTableLoader(true);
      const data = await GetGeoTagEmployeesApi(
        page,
        isActiveFilter,
        "",
        "",
        ""
      );
      setTableLoader(false);

      if (
        data.data.message === "Please Login." ||
        data.data.message === "Invalid Access Token"
      ) {
        navigate("/auth");
      }

      if (data.data.success) {
        setEmployeesData(data.data.data.data);
        setTotal(data.data.data.page_count * 10);
        console.log(data.data.data.data);
      } else {
        api.error({
          message: "Error while fetching Employees List",
          description: data.data.message,
          placement: "top",
        });
      }
    } catch (err) {
      setTableLoader(false);
      api.error({
        message: err.message,
        description: "Try to check your Internet Connection.",
        placement: "top",
      });
    }
  };
  const isGeotagFilteredData = async () => {
    const res = await checkPleaseLogin(navigate);
    if (res) {
      return;
    }
    setEmployeesData(null);
    try {
      setTableLoader(true);
      const data = await GetGeoTagEmployeesApi(
        page,
        "",
        "",
        "",
        isGeotagFilter
      );
      setTableLoader(false);

      if (
        data.data.message === "Please Login." ||
        data.data.message === "Invalid Access Token"
      ) {
        navigate("/auth");
      }

      if (data.data.success) {
        setEmployeesData(data.data.data.data);
        setTotal(data.data.data.page_count * 10);
        console.log(data.data.data.data);
      } else {
        api.error({
          message: "Error while fetching Employees List",
          description: data.data.message,
          placement: "top",
        });
      }
    } catch (err) {
      setTableLoader(false);
      api.error({
        message: err.message,
        description: "Try to check your Internet Connection.",
        placement: "top",
      });
    }
  };

  const handleDelete = async (id, eCode) => {
    const res = await checkPleaseLogin(navigate);
    if (res) {
      return;
    }

    try {
      const data = await DeleteGeoTagEmployeeApi(id);

      if (
        data.data.message === "Please Login." ||
        data.data.message === "Invalid Access Token"
      ) {
        navigate("/auth");
      }

      if (data.data.success) {
        nofilterData();
        api.success({
          message: `Employee (${eCode}) deleted successfully.`,
          placement: "top",
        });
      } else {
        api.error({
          message: `Error while Deleting Employee (${eCode})`,
          description: data.data.message,
          placement: "top",
        });
      }

      console.log(data);
    } catch (err) {
      api.error({
        message: err.message,
        description: "Try to check your Internet Connection.",
        placement: "top",
      });
    }
  };

  const handleactive = ({ key }) => {
    setEmployeeIdFilter("");
    setEmployeeNameFilter("");
    setIsGeotagFilter(null);
    setIsActiveFilter(key);
  };
  const handlegeotag = ({ key }) => {
    setEmployeeIdFilter("");
    setEmployeeNameFilter("");
    setIsActiveFilter(null);
    setIsGeotagFilter(key);
  };

  const onSearch = () => {
    console.log(isActiveFilter);
    if (isActiveFilter !== null || isGeotagFilter !== null) {
      setIsActiveFilter(null);
      setIsGeotagFilter(null);
    } else {
      idNameFilteredData();
    }
  };

  useEffect(() => {
    if (!initialRender.current) {
      if (page !== 1) {
        setPage(1);
      } else if (isActiveFilter !== null || isGeotagFilter !== null) {
        if (isActiveFilter !== null) {
          isActiveFilteredData();
        } else {
          isGeotagFilteredData();
        }
      } else {
        idNameFilteredData();
      }
    }
  }, [isActiveFilter, isGeotagFilter]);

  useEffect(() => {
    initialRender.current = false;
    if (isActiveFilter !== null) {
      isActiveFilteredData();
      setEmployeeIdFilter("");
      setEmployeeNameFilter("");
      setIsGeotagFilter(null);
    } else if (isGeotagFilter !== null) {
      isGeotagFilteredData();
      setEmployeeIdFilter("");
      setIsActiveFilter(null);
      setEmployeeNameFilter("");
    } else {
      idNameFilteredData();
    }
  }, [page]);

  const items = [
    { label: "Yes", key: true },
    { label: "No", key: false },
    { label: "All of the above", key: "" },
  ];

  return (
    <>
      {contextHolder}
      <AddEmployee
        open={addEmployeeToggle}
        onClose={() => setAddEmployeeToggle(false)}
        getEmployeesData={nofilterData}
      />
      <UpdateEmployee
        open={updateEmployeeToggle}
        onClose={() => setUpdateEmployeeToggle(false)}
        defaultValues={defaultValues}
        getEmployeesData={nofilterData}
      />
      <AssetReq
        open={assetReqToggle}
        onClose={() => setAssetReqToggle(false)}
        idAsset={idAsset}
        defaultValues={defaultValues}
        getEmployeesData={nofilterData}
      />

      <section className="bg-white p-3 shadow-sm border border-gray-200 w-full rounded-2xl flex justify-between mb-2">
        <h2 className="text-2xl font-semibold text-gray-800">Employees</h2>
        <div
          className="w-fit px-4 py-2 rounded-md text-white bg-[#009BDE] hover:bg-[#009BDE] shadow-md hover:-translate-y-1 transition-all duration-300 flex items-center justify-center cursor-pointer"
          onClick={() => setAddEmployeeToggle(true)}
        >
          <MdPersonAdd className="text-lg font-bold mr-2" />
          <span className="font-semibold">Add Employee</span>
        </div>
      </section>
      <section className="bg-white p-4 pt-2 shadow-md border border-gray-900 w-full rounded-2xl mb-2">
        <Col className="mt-1 w-full">
          <div className="w-full flex justify-between">
            <Col className="flex gap-2" xs={24} sm={8}>
              <Search
                id="filterId"
                value={employeeIdFilter}
                onChange={(e) => {
                  setEmployeeIdFilter(e.target.value);
                  setEmployeeNameFilter("");
                }}
                onSearch={onSearch}
                className="responsive-search"
                placeholder="Search Employee ID"
              />

              <Search
                id="filterName"
                value={employeeNameFilter}
                onChange={(e) => {
                  setEmployeeNameFilter(e.target.value);
                  setEmployeeIdFilter("");
                }}
                onSearch={onSearch}
                className="responsive-search"
                placeholder="Search Employee Name"
              />
            </Col>
          </div>
        </Col>

        <Col style={{ overflowX: "auto" }}>
          <table className="custom-table mt-2">
            <thead>
              <tr>
                <th>Name</th>
                <th>Official Email ID</th>
                <th>Employee ID</th>
                <th>Biometric ID</th>
                <th>Reporting Manager</th>
                <th>Company</th>

                {/* <th>Department</th>
                <th>Designation</th>
                <th>Location</th>
                <th>Personal Mobile</th>
                <th>Personal Email</th>
                <th>Assigned Items</th> */}

                <Dropdown
                  menu={{ items, onClick: handleactive }}
                  trigger={["click"]}
                >
                  <th style={{ cursor: "pointer" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      Is Active <BiFilterAlt /> <BiChevronDown />
                    </div>
                  </th>
                </Dropdown>

                {/* <Dropdown
                menu={{ items, onClick: handlegeotag }}
                trigger={['click']}
              >
                <th style={{ cursor: 'pointer' }}>
                  Is Geotag <BiFilterAlt /><BiChevronDown />
                </th>
              </Dropdown> */}

                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {employeesData &&
                employeesData.map((val) => (
                  <tr>
                    <td>{val.name}</td>
                    <td>{val.email}</td>
                    <td>{val.employee_id}</td>
                    <td>{val.biometric_id}</td>
                    <td>
                      {val.manager.name}
                      <br></br>
                      {val.manager.employee_id}
                      <br></br>
                      {val.manager.email}
                    </td>
                    <td>{val.company}</td>

                    {/* <td>{val.department}</td>
                    <td>{val.designation}</td>
                    <td>{val.location}</td>
                    <td>{val.mobile}</td>
                    <td>{val.personal_email}</td>
                    <td>
                      {val?.assigned_item?.map(
                        (data) => data?.item?.asset_type + ","
                      )}
                    </td> */}
                    <td>
                      {val.is_active ? (
                        <Badge status="success" text="Yes" />
                      ) : (
                        <Badge status="error" text="No" />
                      )}
                    </td>
                    {/* <td>{val.is_geotag ? <Badge status="success" text="Yes" /> : <Badge status="error" text="No" />}</td> */}

                    {/* <td>{val.is_geotag ? "Geotag" : "Asset"}</td> */}
                    <td>
                      <Row className="justify-content-center flex-nowrap">
                        <div
                          className="action-button mx-2 bg-light bg-gradient"
                          onClick={() => {
                            setDefaultValues(val);
                            setUpdateEmployeeToggle(true);
                          }}
                        >
                          <MdEdit className="text-dark fs-5" />
                        </div>

                        <Popconfirm
                          title={`Are you sure to delete Employee (${val.employee_id})?`}
                          onConfirm={() =>
                            handleDelete(val._id, val.employee_id)
                          }
                          okText="Yes"
                          cancelText="No"
                        >
                          <div className="action-button mx-2 bg-danger bg-gradient">
                            <MdDelete className="fs-5" />
                          </div>
                        </Popconfirm>
                        {/* {val.is_geotag ? (
                          <div style={{ width: "51px" }}></div>
                        ) : (
                          <Tooltip title="Asset Requisition" color="blue" ><div className='action-button mx-2 bg-light bg-gradient' onClick={() => { setIdAsset(val._id); setDefaultValues(val); setAssetReqToggle(true) }}><MdAdd className='text-dark fs-5' /></div></Tooltip>
                          <></>
                        )} */}
                      </Row>
                    </td>
                  </tr>
                ))}
            </tbody>
            <tfoot></tfoot>
          </table>
          {tableLoader && (
            <Row className="justify-content-center py-3">
              <Spin
                size="large"
                indicator={<LoadingOutlined className="text-light" />}
                spinning={true}
              />
            </Row>
          )}
        </Col>
      </section>

      {total > 10 && (
        <div className="round-edges bg-light py-2 my-2 text-center">
          <Pagination
            showSizeChanger={false}
            current={page}
            onChange={(val) => setPage(val)}
            total={total}
            hideOnSinglePage
          />
        </div>
      )}
    </>
  );
}
